
// сладеры

import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination]);

function slider() {

const slider = document.querySelector('.blockSlider__slider')
const sliderTwo = document.querySelector('.blockRow')
const swiper = new Swiper(slider, {
  loop: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },

  navigation: {
    nextEl: '.button-next',
    prevEl: '.button-prev',
  },

  breakpoints: {

    0: {
      slidesPerView: 1,
      spaceBetween: 20
    },

    576: {
      slidesPerView: 'auto',
      spaceBetween: 34,
    },

    1024: {
      slidesPerView: 'auto',
      spaceBetween: 54,
    }
  }
});


  const swiper2 = new Swiper(sliderTwo, {

    slidesPerView: 'auto',
    spaceBetween: 22,


    breakpoints: {
      0: {
        loop: false,
        spaceBetween: 16,
        direction: 'vertical',
      },

      576: {
        loop: true,
        spaceBetween: 22,
        direction: 'horizontal',
        slidesPerView: 'auto',
      },
    },


  })

}

export {
  slider
}
